// extracted by mini-css-extract-plugin
export default {"containerField":"select-array-field_containerField__fLWip","selectIcon":"select-array-field_selectIcon__im-PB","items":"select-array-field_items__WdPSH"};